<div class="system-message">
  <div class="system-line">

    @if (showAuthor || showDate) {
      <span class="system-infos">
        @if (showAuthor && comment.author) {
          <span>{{ comment.author }}</span>
        }
        @if (showAuthor && showDate && comment.author) {
          <span> · </span>
        }
        @if (showDate) {
          <span>
            @if (refreshSince$ | async; as now) {
              {{ comment.dateCreated | since: now }}
            }
          </span>
        }
      </span>
    }
  </div>

  @if (changes.length) {
    <div class="system-changes">
      @for (change of changes; track change) {
        <div class="system-change">
          <span class="system-change-field">{{ getFieldLabel(change.field) }}:</span>
          <span class="system-change-values">
            @if (hasOldValue(change)) {
              {{ formatValue(change.field, change.old) }} →
            }
            {{ formatValue(change.field, change.new) }}
          </span>
        </div>
      }
    </div>
  }
</div>
